import {ArrowRight, Droplets, Sparkles} from 'lucide-react'

const AFFILIATE_URL = "https://cb4789qnsdu2ibjhv3144q1sko.hop.clickbank.net"

export default function AffiliateBanner3() {
  return (
    <section
      aria-label="Sponsored partner offer"
      className="relative bg-white px-4 sm:px-6 py-0"
    >
      <div className="max-w-6xl mx-auto pt-2 pb-6">
        <a
          href={AFFILIATE_URL}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="group relative block overflow-hidden rounded-2xl border border-emerald-100 bg-gradient-to-r from-emerald-700 via-emerald-600 to-slate-800 shadow-lg hover:shadow-emerald-500/25 transition-all duration-300 hover:-translate-y-0.5"
        >
          {/* Decorative glow */}
          <div className="absolute -top-20 -left-20 w-72 h-72 bg-emerald-400/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-20 -right-10 w-64 h-64 bg-slate-500/10 rounded-full blur-3xl pointer-events-none" />

          {/* Subtle dot pattern */}
          <div
            className="absolute inset-0 opacity-[0.06] pointer-events-none"
            style={{
              backgroundImage: "radial-gradient(white 1px, transparent 1px)",
              backgroundSize: "20px 20px",
            }}
          />

          <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 p-5 sm:p-6 lg:p-7">
            {/* Left: Icon + Text */}
            <div className="flex items-start sm:items-center gap-4 flex-1">
              <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center backdrop-blur-sm">
                <Droplets className="w-6 h-6 sm:w-7 sm:h-7 text-emerald-200" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-white/10 border border-white/20 mb-1.5">
                  <Sparkles className="w-3 h-3 text-emerald-200" />
                  <span className="text-[10px] font-bold tracking-wider uppercase text-emerald-200">
                    Sponsored
                  </span>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-white leading-tight">
                  Supercharge Your Weight Loss — Trusted Hydration & Fat Loss Program
                </h3>
                <p className="text-xs sm:text-sm text-emerald-100/80 mt-1 leading-relaxed">
                  Combine optimal water intake with a proven fat loss system for maximum results.
                </p>
              </div>
            </div>

            {/* Right: CTA */}
            <div className="flex-shrink-0 w-full sm:w-auto">
              <span className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-5 py-3 bg-white text-emerald-700 font-semibold rounded-xl group-hover:bg-emerald-50 transition-all shadow-md text-sm sm:text-base">
                Get Started
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </div>
        </a>

        {/* Disclosure */}
        <p className="text-[11px] text-slate-400 text-center mt-3 px-2">
          Affiliate disclosure: We may earn a commission at no extra cost to you.
        </p>
      </div>
    </section>
  )
}
